export function capitalize(str) {
  if (!str) return "";
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export function humanizeText(str) {
  if (!str) return "";
  return str
    .replaceAll("_", " ")
    .split(" ")
    .map((word) => capitalize(word))
    .join(" ")
    .replace("L.l.c.", "LLC")
    .replace("Llc", "LLC")
    .replace("Heb ", "HEB ")
    .replace("Cvs", "CVS");
}

export function toSnakeCase(str) {
  return str.toLowerCase().replace(/[\s-]+/g, "_");
}

export function snakeToTitleKebab(str) {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("-");
}
